export default interface FirebaseError {
  code: string
  message: string
}

// ログインリンクを開いた端末に送信時のメールアドレスが残っていないケース。
// Firebase 由来ではなく AuthContext.signIn が自前で返す。
export const MISSING_EMAIL_CODE = 'app/missing-email-for-signin'

export class MissingEmailForSignInError extends Error implements FirebaseError {
  code = MISSING_EMAIL_CODE

  constructor() {
    super('email for sign-in is not stored in this browser')
    this.name = 'MissingEmailForSignInError'
  }
}

const messages: { [code: string]: string } = {
  'auth/expired-action-code': 'メールリンクの有効期限が切れています',
  'auth/invalid-action-code':
    'このログインリンクは既に使用されているか、無効です。もう一度メールを送信してください',
  'auth/invalid-email': 'メールアドレスが不正です',
  'auth/user-disabled': '無効なユーザーです',
  'auth/network-request-failed':
    'ネットワークに接続できませんでした。通信環境をご確認のうえ、もう一度お試しください',
  'auth/too-many-requests':
    '試行回数が上限に達しました。しばらく時間をおいてからお試しください',
  [MISSING_EMAIL_CODE]:
    'ログインリンクは、メールを送信したのと同じブラウザで開いてください。別の端末やブラウザで開くとログインできません',
}

// 未知のコードは総称文言だけだと原因を特定できないため、コード自体を添える。
export const localizedMessage = (code?: string): string => {
  if (!code) {
    return '認証中にエラーが発生しました'
  }
  return messages[code] ?? `認証中にエラーが発生しました（${code}）`
}
